import Mscolumn2d from"@fusioncharts/charts/src/chart/mscolumn2d";export default Mscolumn2d;